import { menuList,getMenu,articleinfo,ChannelPolicyList,listcompany,listexpert,listcates,listexpertMenu,companyinfo,companyproduct,
    expertinfo,NewMenuList } from '@/api/menu'

const actions = {
    menuList(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            menuList(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getMenu(state, info) {
        console.log("ssssssssss");
        console.log(info);
        const infoData = info
        return new Promise((resolve,reject) => {
            getMenu(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    articleinfo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            articleinfo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    ChannelPolicyList(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            ChannelPolicyList(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listcompany(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listcompany(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listexpert(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listexpert(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listcates(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listcates(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    listexpertMenu(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            listexpertMenu(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    companyinfo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            companyinfo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    companyproduct(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            companyproduct(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    expertinfo(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            expertinfo(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },
    NewMenuList(state, info) {
        const infoData = info
        return new Promise((resolve,reject) => {
            NewMenuList(infoData).then(response => {
                const { data } = response
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    }

}

export default {
  namespaced: true,
  actions
}
